import { graphql } from 'react-relay';

/**
 * Monolith body read used by `refetchPageContent` after a markdown-mode
 * flip. The convert mutation writes the converted body to monolith
 * synchronously; the collab-draft endpoint is async and still serves the
 * pre-convert body for some time after the mutation returns.
 */
export const MarkdownConvertedBodyQuery = graphql`
	query MarkdownConvertedBodyQuery($contentId: ID!, $status: [String]!) {
		content(id: $contentId, status: $status) {
			nodes {
				id
				body {
					atlas_doc_format {
						value
					}
				}
			}
		}
	}
`;
